import * as React from 'react';
import {

    List,
    EditButton,
    Datagrid,
    TextField, ReferenceField, useRecordContext,
    Filter,
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    SelectInput,
    useGetList,
    ShowButton,
} from 'react-admin';
import FormattedDateTimeField from "../../common/FormattedDateTimeField";
import { DeleteWithDialogAction } from "../../common/DeleteWithDialogAction";
import FullNameField from "../../common/FullNameField";
import { SoftDeleteWithDialogAction } from "../../common/SoftDeleteWithDialogAction";
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import useIsPermission from '../../hooks/useIsPermission';
import { useController } from 'react-hook-form';
import { Cs_Issue_Topics } from '../../custom';
import { RESOLUTION_STATUSES } from '../../common/constants';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

function jsonToStringArray(json: any) {
    const data = json;
    return Object.keys(data).map((key) => {
        return `${key}: ${data[key]}`;
    });
}

export function JsonToTagsView({ source }: { source: string }) {
    const record = useRecordContext();
    const data = record[source];
    if (!data) {
        return <></>
    }
    return <div className={'flex flex-wrap gap-1'}>
        {
            jsonToStringArray(data).map((item, index) => {
                return <span key={index} className={'tag px-1 py-0.5 text-xs rounded bg-gray-500 text-white capitalize'}>{item}</span>
            })
        }
    </div>
}



const IssueTopicAutoComplete = (props: any) => {
    const { data, isLoading } = useGetList(
        "issue-topics",
        {
            pagination: { page: 1, perPage: 50 },
            sort: { field: "created_at", order: "DESC" },
            filter: { deleted: false },
        },
        {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        }
    );

    return (
        <AutocompleteInput
            {...props}
            source="issueTopicId"
            label=" Issue Topics"
            choices={data || []}
            optionText="name"
            optionValue="id"
            loading={isLoading}
        />
    );
};

const IssueFilter = (props: any) => {
    return (
        <Filter {...props}>
            <TextInput variant={'outlined'} label="Issue Description" source="issueDescription" alwaysOn={true} defaultValue="" />
            <IssueTopicAutoComplete alwaysOn />
            <SelectInput
                source="resolutionStatus"
                label={'Resolution Status'}
                fullWidth
                alwaysOn={true}
                choices={RESOLUTION_STATUSES}
            />
        </Filter>
    );
}

const IssuesList = () => {
    const { isWritable, isDeletable } = useIsPermission("ISSUE");
    return (
        <List
            queryOptions={{
                refetchOnReconnect: false,
                refetchOnWindowFocus: false,
            }}
            actions={<></>}
            filters={<IssueFilter />}
            sort={{ field: 'createdAt', order: 'DESC' }}>
            <Datagrid>
                <TextField source="issueDescription" />
                <JsonToTagsView source="deviceMeta" /> 
                <TextField source="resolutionStatus" />
                <FormattedDateTimeField source="createdAt" />
                <ShowButton />
                <ConfirmDeleteButton/>
            </Datagrid>
        </List>
    );
};
export default IssuesList;
